export default __webpack_public_path__ + "static/SEO -71497610284932d748d390e5b2f95069.jpeg";